export default __webpack_public_path__ + "static/media/icon-add-circle-outline.62af2087.svg";